import { useFrame } from '@react-three/fiber';
import { tickSky } from './skyState';

// Advances the shared sky state once per frame, before anything that reads it.
// Mounted first in SceneContents so the light rig, the reflection probe and the
// post pass all see this frame's sun rather than last frame's. `pin` is the
// room's pinned hour (rooms.js timeOfDay) — the same pin useWorldTime honours.
export default function SkyClock({ timeZone, pin = null }) {
  useFrame((state, dt) => { tickSky(timeZone, pin, state.clock.elapsedTime, dt); }, -1);
  return null;
}
